import Schedule from './pages/Schedule';

export default Schedule;
